import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as EmployeeDocActions from '../_actions/employeeDoc';
import { EmployeeDoc } from '../_models/employeeDoc';

export interface EmployeeDocState extends EntityState<EmployeeDoc> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<EmployeeDoc> = createEntityAdapter<EmployeeDoc>();

const initialState: EmployeeDocState = adapter.getInitialState({
  loading: false,
  error: null,
});

const employeeDocReducer = createReducer(
  initialState,

  on(EmployeeDocActions.loadEmployeeDocs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EmployeeDocActions.loadEmployeeDocsSuccess, (state, { employeeDocs }) =>
    adapter.setAll(employeeDocs, { ...state, loading: false })
  ),

  on(EmployeeDocActions.loadEmployeeDocsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EmployeeDocActions.addEmployeeDocSuccess, (state, { employeeDoc }) =>
    adapter.addOne(employeeDoc, state)
  ),

  on(EmployeeDocActions.updateEmployeeDocSuccess, (state, { employeeDoc }) =>
    adapter.upsertOne(employeeDoc, state)
  ),

  on(EmployeeDocActions.deleteEmployeeDocSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    EmployeeDocActions.addEmployeeDocFailure,
    EmployeeDocActions.updateEmployeeDocFailure,
    EmployeeDocActions.deleteEmployeeDocFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: EmployeeDocState | undefined, action: Action) {
  return employeeDocReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
